export interface Tomo {
  number: string;
  title: string;
  description: string;
  tag: string;
  coverImage: string;
}

export const tomos: Tomo[] = [
  {
    number: '01',
    title: 'Root-Cause Clinical Assessment & Anamnesis',
    description:
      'Detect hidden metabolic triggers in the first 15 minutes. High-impact filtering questions, comprehensive clinical evaluation, and commitment-based session close.',
    tag: '50 pages · Clinical cases included',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/2Y9JL5tc6nwVd1cHRbwAyj/ChatGPT-Image-25-jul-2026_-10_57_21-p.m..webp',
  },
  {
    number: '02',
    title: 'Functional Lab Interpretation & Biochemistry',
    description:
      'Interpret blood work with real clinical precision. Optimal vs. normal ranges. Adjust plans based on biochemical markers using step-by-step protocols.',
    tag: '50 pages · Reference tables included',
    coverImage: 'https://cdn.magicpatterns.com/uploads/oAGGkojS925M32tWusK3Nf/ChatGPT-Image-25-jul-2026_-10_57_15-p.m..webp',
  },
  {
    number: '03',
    title: 'The Meal Engineering & Macro System™',
    description:
      'Build personalized meal plans in under 5 minutes using the Nutritional Block Loading System™. Never start from scratch again.',
    tag: '50 pages · Full block library included',
    coverImage: 'https://cdn.magicpatterns.com/uploads/aW8fCxKZsdUUGeREuZWBis/ChatGPT-Image-25-jul-2026_-10_57_10-p.m..webp',
  },
  {
    number: '04',
    title: 'The Clinical Protocol Vault™',
    description:
      'Evidence-based protocols for Diabetes, PCOS, Hypothyroidism, Dyslipidemia, Obesity, and Gastrointestinal Conditions.',
    tag: '50 pages · 6 complete clinical protocols',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/hJMQDsPre6ty3RV7NFnHux/ChatGPT-Image-25-jul-2026_-10_57_04-p.m..webp',
  },
  {
    number: '05',
    title: 'The Patient Education & Visual Nutrition System™',
    description:
      'Clear visual guides for portions, food labels, and healthy habits. The Hand Portion System™ and NutriPro Plate Method™.',
    tag: '50 pages · Patient-ready materials included',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/p2Sjgean7SbD1p5AtavyWv/ChatGPT-Image-25-jul-2026_-10_56_59-p.m..webp',
  },
  {
    number: '06',
    title: 'Patient Retention & Practice Growth OS',
    description:
      'Proven strategies to increase treatment adherence, retain high-value patients, elevate your professional brand, and scale your virtual practice.',
    tag: '50 pages · Retention protocols included',
    coverImage:
      'https://cdn.magicpatterns.com/uploads/4QyjQBE77r7Q3Dd5GXSNri/ChatGPT-Image-25-jul-2026_-10_56_55-p.m..webp',
  },
];

export interface Bono {
  badge: string;
  icon: string;
  title: string;
  description: string;
  value: string;
}

export const bonos: Bono[] = [
  {
    badge: 'BONUS 01',
    icon: '💬',
    title: 'The Clinical Forms & Templates Vault™',
    description:
      '50+ ready-to-use professional forms, intake templates, consent agreements, and clinical checklists. Copy, customize, and use immediately.',
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 02',
    icon: '📊',
    title: 'The Patient Education Library™',
    description:
      '30+ done-for-you patient handouts, visual infographics, and education sheets designed for maximum understanding and compliance.',
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 03',
    icon: '⚖️',
    title: 'The 90-Day Practice Launch Blueprint™',
    description:
      'Your complete step-by-step action plan to launch, fill, and profit from your nutrition practice in 90 days.',
    value: 'Value: $47 USD',
  },
  {
    badge: 'BONUS 04',
    icon: '💊',
    title: 'Legal & Liability Safety Vault™',
    description:
      'Professional consent forms, service contracts, privacy policies, and scope-of-practice templates to fully protect your license and practice.',
    value: 'Value: $47 USD',
  },
];

export interface Testimonial {
  text: string;
  name: string;
  city: string;
  role: string;
  initials: string;
}

export const testimonials: Testimonial[] = [
  {
    text: 'I had been improvising my consultations for years. With this system I built a real clinical workflow in less than one week. Volume 03 alone was worth every penny.',
    name: 'Valentina R.',
    city: 'Buenos Aires, Argentina',
    role: 'Independent Clinical Nutritionist',
    initials: 'VR',
  },
  {
    text: 'The Clinical Forms Vault completely changed how I onboard and communicate with my patients. Last-minute cancellations dropped and treatment adherence went up significantly.',
    name: 'Daniela M.',
    city: 'Mexico City, Mexico',
    role: 'Nutritionist & Habit Coach',
    initials: 'DM',
  },
  {
    text: 'The clinical protocols in Volume 04 are exactly what I needed to approach PCOS and Hypothyroidism cases with confidence and zero guesswork.',
    name: 'Carolina S.',
    city: 'Bogotá, Colombia',
    role: 'Hormonal Health Nutritionist',
    initials: 'CS',
  },
  {
    text: 'I thought it was just another PDF. It turned out to be the most complete clinical resource I own. The Legal Vault from Bonus 04 is now standard in every new patient onboarding.',
    name: 'Francisca T.',
    city: 'Santiago, Chile',
    role: 'Clinical & Sports Nutritionist',
    initials: 'FT',
  },
  {
    text: 'I purchased from Peru with no issues at all. The platform processed payment in my local currency automatically and I downloaded everything in minutes. The clinical depth here is unlike anything else available.',
    name: 'Alejandra V.',
    city: 'Lima, Peru',
    role: 'Hospital Nutritionist',
    initials: 'AV',
  },
  {
    text: 'The Nutritional Block Loading System in Volume 03 saved me hours of work every single week. I now build plans in minutes and my patients understand them far better.',
    name: 'Mariana F.',
    city: 'Montevideo, Uruguay',
    role: 'Pediatric & Family Nutritionist',
    initials: 'MF',
  },
  {
    text: 'I run a fully virtual practice and this system works perfectly for that format. Volume 06 had everything I needed to systematize and professionalize my online consultations.',
    name: 'Gabriela P.',
    city: 'Caracas, Venezuela',
    role: 'Online Nutrition Professional',
    initials: 'GP',
  },
];

export interface Notification {
  name: string;
  location: string;
  time: string;
}

export const notifications: Notification[] = [
  { name: 'Sarah M.', location: 'New York, United States', time: '2 minutes ago' },
  { name: 'Jessica L.', location: 'Los Angeles, United Kingdom', time: '5 minutes ago' },
  { name: 'Emily R.', location: 'Chicago, Canada', time: '8 minutes ago' },
  { name: 'Amanda K.', location: 'London, Australia', time: '11 minutes ago' },
  { name: 'Nicole T.', location: 'Toronto, United States', time: '14 minutes ago' },
  { name: 'Rachel H.', location: 'Sydney, New Zealand', time: '18 minutes ago' },
  { name: 'Lauren B.', location: 'Miami, United States', time: '22 minutes ago' },
  { name: 'Olivia R.', location: 'Boston, United States', time: '26 minutes ago' },
  { name: 'Megan V.', location: 'Manchester, United Kingdom', time: '31 minutes ago' },
  { name: 'Hannah M.', location: 'Vancouver, Canada', time: '35 minutes ago' },
  { name: 'Chloe R.', location: 'Melbourne, Australia', time: '41 minutes ago' },
  { name: 'Sophie B.', location: 'Seattle, United States', time: '47 minutes ago' },
  { name: 'Emma S.', location: 'Auckland, New Zealand', time: '52 minutes ago' },
  { name: 'Grace C.', location: 'Dallas, United States', time: '58 minutes ago' },
  { name: 'Lily P.', location: 'Birmingham, United Kingdom', time: '1 hour ago' },
  { name: 'Natalie F.', location: 'Calgary, Canada', time: '1 hour and 8 min ago' },
  { name: 'Paige M.', location: 'Brisbane, Australia', time: '1 hour and 15 min ago' },
  { name: 'Victoria T.', location: 'San Diego, United States', time: '1 hour and 24 min ago' },
  { name: 'Monica R.', location: 'Wellington, New Zealand', time: '1 hour and 33 min ago' },
  { name: 'Stephanie L.', location: 'London, United Kingdom', time: '1 hour and 45 min ago' },
];

export const faqs = [
  {
    question: 'How do I receive the system after purchasing?',
    answer:
      'You get instant access to all 10 PDF files as soon as payment is confirmed. No waiting, no apps, accessible from any device.',
  },
  {
    question: 'Is this a one-time payment or a subscription?',
    answer:
      'It is a one-time payment of $27 USD. There are no subscriptions, recurring charges, or hidden costs. You receive lifetime access to the complete system.',
  },
  {
    question: 'Can I purchase this from my country?',
    answer:
      'Yes. The system is available worldwide. The platform detects your country and automatically converts the price to your local currency before you confirm payment.',
  },
  {
    question: "What happens if it doesn't work for me?",
    answer:
      'You are protected by a 14-day money-back guarantee. If within the first two weeks it is not what you expected, we will refund 100% of your investment. No complicated process.',
  },
  {
    question: 'Is this a video course or academic certification?',
    answer:
      'No. This is a ready-to-use digital consultation system in PDF format. It does not include video classes or academic certification—it is practical clinical content you can use today.',
  },
  {
    question: 'Do I need to install anything to use it?',
    answer:
      'No. These are PDF files you can open on any device: phone, tablet, or computer. No apps or additional software needed.',
  },
];
